import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from 'src/app/services/requestService/request.service';

@Component({
  selector: 'app-register-activation',
  templateUrl: './register-activation.component.html',
  styleUrls: ['./register-activation.component.less']
})
export class RegisterActivationComponent implements OnInit {
  message;
  constructor(private activatedRoute: ActivatedRoute, private requestService: RequestService) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.checkToken(this.activatedRoute.snapshot.params['token']);
    });
  }

  // Check Token and activate account
  checkToken(token: string) {
    let req = {
      url: "/api/auth/activate",
      req: {
        token: token
      }
    };
    this.requestService.mainPostRequest(req).then((resp:any) => {
      if(resp.success){
        this.message = "register_success_msg";
      }else{
        this.message = resp.errorCode;
      }      
    });
  }
}